import { 
    UPDATE_WAITING, 
    UPDATE_ABANDON, 
    UPDATE_CONNECTED, 
    UPDATE_COMPLETED, 
 } from '../actions/types';

const INITIAL_STATE = {
    waiting: {},
    abandon: {},
    queuesListener: [],
    abandoned: [],
    connected: [],
    completed: [],
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_WAITING:
            return { ...state, waiting: action.payload } 
        case UPDATE_ABANDON:
            return { ...state, abandoned: action.payload } 
        case UPDATE_CONNECTED:
            return { ...state, connected: action.payload } 
        case UPDATE_COMPLETED:
            return { ...state, completed: action.payload } 

        default:
            return state;   
    }
}